import { currentUser } from "@app/routes/auth/selectors";
import { ROLES } from "@app/constants";
import { STEPS } from "@app/routes/activities/spelling/constants";
import {
  setCurrentWordId, setCurrentStep, setCodingLetterCode, updateStudentWord,
  setIsListen, setIsEcho, setIsSpell, setIsWrite, setIsCoding, setIsSubmit,
  setTherapistWordId,
} from "@app/routes/activities/spelling/store/spellingSlice";
import { trackSpellingEvent as TSE } from "./spelling";

export const relevantSpellingBeforeActions = {

};

export const relevantSpellingAfterTherapistActions = {
  [setTherapistWordId]: (stateBefore, stateAfter, boardId, action) => {
    const params = {
      word_id: action?.payload?.value,
      is_submit: action?.payload?.isSubmit,
    };
    TSE("spelling_set_therapist_word", stateAfter, boardId, params);
  },
  [setIsSubmit]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value };
    TSE("spelling_is_submit", stateAfter, boardId, params);
  },
};

export const relevantSpellingAfterStudentActions = {
  [setCurrentWordId]: (stateBefore, stateAfter, boardId, action) => {
    const params = {
      word_id: action?.payload?.value?.wordId,
    };
    TSE("spelling_set_student_word", stateAfter, boardId, params);
  },
  [setIsSubmit]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value };
    TSE("spelling_is_submit", stateAfter, boardId, params);
  },
  [setIsEcho]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value };
    TSE("spelling_is_echo", stateAfter, boardId, params);
  },
  [setIsListen]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value };
    TSE("spelling_is_listen", stateAfter, boardId, params);
  },
  [setIsSpell]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value,
    };
    TSE("spelling_is_spell", stateAfter, boardId, params);
  },
  [setIsWrite]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value };
    TSE("spelling_is_write", stateAfter, boardId, params);
  },
  [setIsCoding]: (stateBefore, stateAfter, boardId, action) => {
    const params = { manual: true, checked: !!action?.payload?.value };
    TSE("spelling_is_coding", stateAfter, boardId, params);
  },
  [setCodingLetterCode]: (stateBefore, stateAfter, boardId, action) => {
    const codeId = action?.payload?.value?.codeId;
    const newState = action?.payload?.value?.newState;

    TSE(newState ? "spelling_coding_letter" : "spelling_uncoding_letter", stateAfter, boardId, { code_id: codeId });

    const isCodingUpdate = action?.payload?.isCoding;
    const params = { manual: false, checked: !!action?.payload?.value };
    !isCodingUpdate && TSE("spelling_is_coding", stateAfter, boardId, params);
  },
  [setCurrentStep]: (stateBefore, stateAfter, boardId, action) => {
    const params = {
      step: Object.keys(STEPS).find(key => STEPS[key] === action?.payload?.value),
    };
    TSE("spelling_set_current_step", stateAfter, boardId, params);
  },
  [updateStudentWord]: (stateBefore, stateAfter, boardId, action) => {
    const isWriteUpdate = action?.payload?.isWrite;
    TSE("spelling_update_written_word", stateAfter, boardId, {});

    const params = { manual: false, checked: !!action?.payload?.value?.word };
    !isWriteUpdate && TSE("spelling_is_write", stateAfter, boardId, params);
  },
};

export const spellingActionsRouterAfter = (stateBefore, stateAfter, action) => {
  const currUser = currentUser(stateAfter);
  const boardId = action?.payload?.boardId;
  currUser.role === ROLES.THERAPIST.id && relevantSpellingAfterTherapistActions[action.type]?.(stateBefore, stateAfter, boardId, action);
  currUser.role === ROLES.STUDENT.id && relevantSpellingAfterStudentActions[action.type]?.(stateBefore, stateAfter, boardId, action);
};
